import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import styles from './styles.scss'
import VenuesMobileTable from './venuesMobileTable'
const cx = classnames.bind(styles)

const VenuesMobileModalContent = ({ submitMobileVenues, elmId, ...props }) => {
  return (
    <div className={cx('modal-body')}>
      <VenuesMobileTable elmId={elmId} {...props} />
      <Button
        elmId={elmId + '_venues_apply_btn_mobile'}
        role='primary'
        className={cx('button-is-stretch', 'mobile-apply-btn')}
        onClick={submitMobileVenues}
      >
        Apply
      </Button>
    </div>
  )
}

VenuesMobileModalContent.propTypes = {
  elmId: PropTypes.string.isRequired,
  submitMobileVenues: PropTypes.func.isRequired,
}

export default VenuesMobileModalContent
